// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box-error[data-v-1fac01f0]{color:#fff;position:fixed;background:rgba(205,0,94,.95);margin:0;z-index:100;width:100%;top:0}.cursor-pointer[data-v-1fac01f0]{cursor:pointer}.icon-div[data-v-1fac01f0]{right:0}@media only screen and (min-width:768px){.message-div[data-v-1fac01f0]{margin:0 auto}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
